import { collectElementIntent } from './collector';
import { siteConfig } from './config';
import { actionableElement } from './detector';
import { captureUrlAttribution } from './identity';
import { trackPageViews } from './pageview';
import type { SiteConfig } from './types';

declare global {
  interface Window {
    __mysiteEmbedLoaded?: boolean;
  }
}

// SPA frameworks with SSR can execute the bundle twice (server HTML + hydration).
// Guard so listeners and the load page_view fire only once per page.
if (!window.__mysiteEmbedLoaded) {
  window.__mysiteEmbedLoaded = true;
  const config = siteConfig();
  if (config) {
    captureUrlAttribution();
    trackPageViews(config);
    installListeners(config);
  }
}

function installListeners(config: SiteConfig): void {
  document.addEventListener(
    'click',
    (event) => {
      const element = actionableElement(event.target);
      if (!element) return;
      void collectElementIntent(element, config, 'click_capture');
    },
    { capture: true },
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      void collectElementIntent(event.target, config, 'form_submit');
    },
    { capture: true },
  );

  document.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const element = actionableElement(event.target);
      if (!element) return;
      void collectElementIntent(element, config, 'keyboard_capture');
    },
    { capture: true },
  );
}
